<script setup lang="ts">
// import Uploader from '@/components/files/Uploader.vue';

type GdsName = "AMADEUS" | "SABRE";

interface TravelAgencyOffice {
  name: string;
  gdsName: GdsName;
  amadeusOfficeId: string;
  lastImportDate?: Date;
}

const travelAgencyOffices: TravelAgencyOffice[] = [
  {
    name: "Loisir",
    gdsName: "AMADEUS",
    amadeusOfficeId: "PARMM21LY",
    lastImportDate: new Date(),
  },
  {
    name: "LCI",
    gdsName: "AMADEUS",
    amadeusOfficeId: "PARMM2519",
    lastImportDate: new Date(),
  }
]
</script>
<template>
<div class="flex w-full p-12">

  <!-- <Uploader /> -->

  <embed src="https://ucarecdn.com/3c2cdd8a-7f63-4bf5-8d88-1e3a346f3d9e/PresentationLegalCare.pdf" type="application/pdf" width="100%" height="600px" />


  <article
    v-for="travelAgencyOffice in travelAgencyOffices"
    class="flex flex-col gap-4 p-6 mr-8 bg-white border border-gray-100 rounded-lg"
  >
    <div
      class="inline-flex self-end gap-2 p-1 text-green-600 bg-green-100 rounded"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
        />
      </svg>

      <span class="text-xs font-medium"> +17 claims (sur 30j) </span>
    </div>

    <div>
      <strong class="block text-sm font-medium text-gray-500"> Nom </strong>

      <p>
        <span class="text-2xl font-medium text-gray-900"> {{ travelAgencyOffice.name }} </span>

        <span class="text-xs text-gray-500"> from $240.94 </span>
      </p>
    </div>
  </article>
</div>
</template>